import { CollectionName, CollectionVisibility } from "../registry/collection-registry"
import type { CollectionCreateSchema } from "../types/typesense"

export const cnCodesSchema: CollectionCreateSchema = {
  name: CollectionName.CnCodes,
  fields: [
    {
      name: "label",
      type: "string",
      facet: false,
      infix: true,
    },
    {
      name: "search_id",
      type: "string",
      facet: false,
    },
    {
      name: "cn_code",
      type: "string",
      facet: false,
      infix: true,
      sort: true,
    },
    {
      name: "group",
      type: "string",
      facet: true,
    },
    {
      name: "group_order",
      type: "int32",
      facet: true,
      sort: true,
    },
    {
      name: "order",
      type: "int32",
      facet: true,
      sort: true,
      optional: true,
    },
    {
      name: "eu_category",
      type: "string",
      facet: true,
      infix: true,
    },
    {
      name: "eu_grape_variety",
      type: "bool",
      facet: true,
    },
    {
      name: "eu_grape_variety_label",
      type: "string",
      facet: false,
      infix: true,
    },
    {
      name: "color",
      type: "string[]",
      facet: true,
      infix: true,
    },
    {
      name: "bottle_size",
      type: "string",
      facet: true,
      infix: true,
    },
    {
      name: "bottle_size_min_litres",
      type: "int32",
      facet: true,
      optional: true,
    },
    {
      name: "bottle_size_max_litres",
      type: "int32",
      facet: true,
      optional: true,
    },
  ],
  visibility: CollectionVisibility.EC,
}
